var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2Empresas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#189CD8",
    cx: 35,
    cy: 35,
    r: 35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.845,20.49v-7.24h-3.22v7.24H40.35v35.982h13.771V20.49H48.845z M49.717,48.424h-4.965v-3.221h4.965 V48.424z M49.717,41.985h-4.965v-3.221h4.965V41.985z M49.717,35.547h-4.965v-3.221h4.965V35.547z M49.717,29.107h-4.965v-3.22 h4.965V29.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.038,51.643h3.22v4.83h-3.22V51.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.166,56.473h5.653v-8.049h9.658v8.049h5.652v-47.5l-20.964,4.932V56.473z M28.258,19.448h4.966v3.22 h-4.966V19.448z M28.258,25.888h4.966v3.22h-4.966V25.888z M28.258,32.326h4.966v3.221h-4.966V32.326z M28.258,38.765h4.966v3.221 h-4.966V38.765z M20.073,19.448h4.965v3.22h-4.965V19.448z M20.073,25.888h4.965v3.22h-4.965V25.888z M20.073,32.326h4.965v3.221 h-4.965V32.326z M20.073,38.765h4.965v3.221h-4.965V38.765z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Empresas);
export default __webpack_public_path__ + "static/media/2-Empresas.0a860af3e61200cf872342c7b4e23f6e.svg";
export { ForwardRef as ReactComponent };